import { Share2, Facebook, MessageCircle, Mail, Link2 } from "lucide-react";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

const XIcon = ({ size = 16 }) => <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" /></svg>;

export const ShareMenu = ({ path, title, kind = "opportunity", className = "", testId = "share" }) => {
  const url = `${window.location.origin}${path}`;
  const text = kind === "going" ? `I'm going: ${title} — join me on RippleImpact. Be the Change.` : `${title} — ${kind === "story" ? "read it" : "a way to help"} on RippleImpact. Be the Change.`;
  const e = encodeURIComponent;
  const links = [
    ["facebook", "Facebook", Facebook, `https://www.facebook.com/sharer/sharer.php?u=${e(url)}`],
    ["x", "X", XIcon, `https://twitter.com/intent/tweet?text=${e(text)}&url=${e(url)}`],
    ["whatsapp", "WhatsApp", MessageCircle, `https://wa.me/?text=${e(`${text} ${url}`)}`],
    ["email", "Email", Mail, `mailto:?subject=${e(`${title} · RippleImpact`)}&body=${e(`${text}\n\n${url}`)}`],
  ];
  const copy = () => navigator.clipboard.writeText(url).then(() => toast.success("Link copied")).catch(() => toast.error("Couldn't copy — select the address bar instead"));
  const stop = (ev) => ev.stopPropagation();
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button onClick={stop} aria-label="Share" data-testid={`${testId}-btn`} className={`inline-flex items-center justify-center gap-1.5 rounded-full border border-slate-300 bg-white p-2.5 text-slate-700 transition-colors hover:border-[#1E3A8A] hover:text-[#1E3A8A] ${className}`}>
          <Share2 size={16} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="share-pop w-56 rounded-2xl bg-white p-2" onClick={stop} data-testid={`${testId}-menu`}>
        <p className="share-pop-title px-3 pb-1 pt-2 text-xs font-semibold uppercase tracking-wider text-[#1E3A8A]">Share a Ripple</p>
        {links.map(([k, l, Icon, href]) => (
          <a key={k} href={href} target="_blank" rel="noopener noreferrer" data-testid={`${testId}-${k}`} className="flex items-center gap-3 rounded-xl px-3 py-2 text-sm text-slate-800 hover:bg-slate-100"><Icon size={16} />{l}</a>
        ))}
        <button onClick={copy} data-testid={`${testId}-copy`} className="flex w-full items-center gap-3 rounded-xl px-3 py-2 text-left text-sm text-slate-800 hover:bg-slate-100"><Link2 size={16} />Copy link</button>
      </PopoverContent>
    </Popover>
  );
};
